import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.scss";
import Logo from "../../../assets/wlc-logo-text.png";
import LogoSimple from "../../../assets/wlc-logo-simple.png";
import { IoChevronDown } from "react-icons/io5";
import { menuItems } from "./data/data";
import { LuArrowLeftToLine, LuArrowRightToLine } from "react-icons/lu";

const Sidebar = ({ isOpen, isCollapsed, onToggleCollapse, onClose }) => {
    const [openMenus, setOpenMenus] = useState({});
    const [hoveredItem, setHoveredItem] = useState(null);
    const location = useLocation();

    const toggleMenu = (menuKey) => {
        if (
            isCollapsed &&
            menuItems.find((item) => item.key === menuKey)?.hasSubmenu
        ) {
            onToggleCollapse();
        }

        setOpenMenus((prev) => ({
            ...prev,
            [menuKey]: !prev[menuKey],
        }));
    };

    const toggleCollapse = () => {
        onToggleCollapse();
        if (!isCollapsed) {
            setOpenMenus({});
        }
    };

    const handleItemHover = (itemKey, isHovering) => {
        if (isCollapsed) {
            setHoveredItem(isHovering ? itemKey : null);
        }
    };

    const isActiveRoute = (path) => {
        return (
            location.pathname === path ||
            location.pathname.startsWith(path + "/")
        );
    };

    const hasActiveSubmenu = (submenu) => {
        return submenu.some((subItem) => isActiveRoute(subItem.path));
    };

    const handleLinkClick = () => {
        if (window.innerWidth <= 768) {
            onClose();
        }
    };

    return (
        <aside
            className={`sidebar ${isCollapsed ? "sidebar--collapsed" : ""} ${
                isOpen ? "sidebar--open" : ""
            }`}
        >
            <div className="sidebar__header">
                <div className="sidebar__logo">
                    <img
                        src={isCollapsed ? LogoSimple : Logo}
                        alt="WLC Logo"
                        className="sidebar__logo-img"
                    />
                </div>
            </div>

            <nav className="sidebar__nav">
                <ul className="sidebar__menu">
                    {menuItems.map((item) => (
                        <li
                            key={item.key}
                            className="sidebar__menu-item"
                            onMouseEnter={() => handleItemHover(item.key, true)}
                            onMouseLeave={() =>
                                handleItemHover(item.key, false)
                            }
                        >
                            {isCollapsed && hoveredItem === item.key && (
                                <div className="sidebar__tooltip">
                                    {item.title}
                                </div>
                            )}

                            {item.hasSubmenu ? (
                                <>
                                    <button
                                        className={`sidebar__menu-link sidebar__menu-link--expandable ${
                                            openMenus[item.key]
                                                ? "sidebar__menu-link--expanded"
                                                : ""
                                        } ${
                                            hasActiveSubmenu(item.submenu)
                                                ? "sidebar__menu-link--active"
                                                : ""
                                        }`}
                                        onClick={() => toggleMenu(item.key)}
                                        title={
                                            isCollapsed ? item.title : undefined
                                        }
                                    >
                                        <span className="sidebar__menu-icon">
                                            <item.icon />
                                        </span>
                                        {!isCollapsed && (
                                            <>
                                                <span className="sidebar__menu-text">
                                                    {item.title}
                                                </span>
                                                <IoChevronDown className="sidebar__menu-arrow" />
                                            </>
                                        )}
                                    </button>
                                    {!isCollapsed && openMenus[item.key] && (
                                        <ul className="sidebar__submenu">
                                            {item.submenu.map((subItem) => (
                                                <li
                                                    key={subItem.path}
                                                    className="sidebar__submenu-item"
                                                >
                                                    <Link
                                                        to={subItem.path}
                                                        className={`sidebar__submenu-link ${
                                                            isActiveRoute(
                                                                subItem.path
                                                            )
                                                                ? "sidebar__submenu-link--active"
                                                                : ""
                                                        }`}
                                                        onClick={
                                                            handleLinkClick
                                                        }
                                                    >
                                                        {subItem.title}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </>
                            ) : (
                                <Link
                                    to={item.path}
                                    className={`sidebar__menu-link ${
                                        isActiveRoute(item.path)
                                            ? "sidebar__menu-link--active"
                                            : ""
                                    }`}
                                    title={isCollapsed ? item.title : undefined}
                                    onClick={handleLinkClick}
                                >
                                    <span className="sidebar__menu-icon">
                                        <item.icon />
                                    </span>
                                    {!isCollapsed && (
                                        <span className="sidebar__menu-text">
                                            {item.title}
                                        </span>
                                    )}
                                </Link>
                            )}
                        </li>
                    ))}
                </ul>
            </nav>

            <div className="sidebar__footer">
                <button
                    className="sidebar__collapse-btn"
                    onClick={toggleCollapse}
                    title={isCollapsed ? "Expandir menú" : "Contraer menú"}
                >
                    {isCollapsed ? (
                        <LuArrowRightToLine />
                    ) : (
                        <LuArrowLeftToLine />
                    )}{" "}
                </button>
            </div>
        </aside>
    );
};

export default Sidebar;
